<template>
  <div
    class="publicNav flex"
    :class="[deviceInfo.type]"
    :style="{
      background: `linear-gradient(90deg,${currentSkin.topBg[0]} 0%,${currentSkin.topBg[1]} 100%)`,
    }"
  >
    <div class="min-480 title flex">
      <span
        v-if="layoutMode == 'navFull'"
        :style="{
          color: currentSkin ? currentSkin.topColor : '',
        }"
      >
        <span style="font-size: 26px; margin-left: 20px; letter-spacing: 2px"
          >{{ $t("nav.platform_name") }}</span
        >
        <!-- <logo-box :toggle-open="false"></logo-box> -->
      </span>

      <el-breadcrumb
        separator="/"
        style="margin-left: 10px"
        v-if="showBreadcrumb"
      >
        <el-breadcrumb-item v-for="item in breadcrumb" :key="item.name">
          <em
            class="breadcrumbSpan"
            :style="{
              color: currentSkin ? currentSkin.topColor : '',
            }"
          >
            {{ item.label }}
          </em>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="min-480 topNav" v-if="navMode != 'default'">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        :background-color="currentSkin.topBg[0]"
        text-color="#ffffff"
        active-text-color="#0077FF"
      >
        <el-menu-item v-for="item in nav" :key="item.name" :index="item.name">{{
          routeTitle(item)
        }}</el-menu-item>
      </el-menu>
    </div>

    <div class="max-480 flex small">
      <div
        class="flex small-icon"
        :class="{ flexd: isSideOpen }"
        @click="toggleOpenSide"
      >
        <i
          class="el-icon-menu"
          v-if="!isSideOpen"
          :style="{
            color: currentSkin ? currentSkin.topColor : '',
          }"
        ></i>
        <i
          class="el-icon-error"
          v-else
          :style="{
            color: currentSkin ? currentSkin.topColor : '',
            fontSize: '20px',
          }"
        ></i>
      </div>
      <el-popover placement="bottom" trigger="click">
        <div class="langList">
          <h3>{{ $t("public.language") }}</h3>
          <div
            class="flex"
            :class="{ langListCheck: lang.isCheck }"
            v-for="lang in langEnum"
            :key="lang.type"
            @click="handleChangeLang(lang)"
          >
            <i class="el-icon-s-flag"></i>
            <span>
              {{ lang.label }}
            </span>
          </div>
        </div>
        <div class="flex langBox" slot="reference">
          <i class="el-icon-s-flag"></i>
          <span class="omit-1">{{ showLang.label }}</span>
          <!-- <i class="el-icon-arrow-down"></i> -->
          <i class="el-icon-arrow-down"></i>
        </div>
      </el-popover>
    </div>
    <div
      class="max-480 small-title"
      :style="{
        color: currentSkin ? currentSkin.topColor : '',
      }"
    >
      {{ snName ? `SN: ${snName}` : "" }}
    </div>
    <div class="account flex">
      <el-dropdown
        class="min-480 nav-lang"
        trigger="click"
        placement="bottom-end"
        @command="handleChangeLang"
        @visible-change="langMenuVisible = $event"
      >
        <button
          type="button"
          class="lang-trigger"
          :aria-label="$t('public.language') + ': ' + curLangLabel"
          :aria-expanded="String(langMenuVisible)"
          @keydown.enter.prevent
        >
          <svg class="lang-globe" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
            <circle cx="12" cy="12" r="9" />
            <ellipse cx="12" cy="12" rx="4" ry="9" />
            <path d="M3 12h18" />
          </svg>
          <span class="lang-current">{{ curLangLabel }}</span>
          <i class="el-icon-arrow-down lang-arrow" :class="{ expanded: langMenuVisible }" aria-hidden="true"></i>
        </button>
        <el-dropdown-menu slot="dropdown" class="nav-lang-menu">
          <el-dropdown-item
            v-for="l in langEnum"
            :key="l.type"
            :command="l"
            class="nav-lang-option"
            :class="{ active: l.isCheck }"
          >
            <span>{{ l.label }}</span>
            <i v-if="l.isCheck" class="el-icon-check" aria-hidden="true"></i>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <span class="min-480 account-sn" v-if="snName"> SN：{{ snName }}</span>
			<img
				class="min-480 account-reveice"
				src="@/assets/images/public/reveice.png"
				alt=""
			/> -->
      <div class="document" @click="goDocument">{{ $t("nav.develop_doc") }}</div>
      <el-popover
        placement="bottom-start"
        trigger="click"
        popper-class="select-popover"
        @show="toggleChangeIcon"
        @hide="toggleChangeIcon"
      >
        <div class="account-select">
          <div
            class="select-one flex"
            v-for="item in selects"
            :key="item.type"
            @click="handleClick(item)"
          >
            <img :src="item.icon" class="img" alt="" />
            <img :src="item.actIcon" class="img_act" alt="" />
            <span>
              {{ item.label }}
            </span>
          </div>
        </div>
        <div class="flex account-info" slot="reference">
          <!-- <el-avatar
            class="min-480"
            size="medium"
            src="https://dummyimage.com/50x50/000/fff"
          ></el-avatar> -->
          <span style="color: #ffffff; margin: 0 10px">{{ snName }}</span>
          <!-- <span style="color: #ffffff; margin: 0 6px">{{ userName }}</span> -->
          <i
            class="iconfont icon-geren"
            :style="{
              // color: currentSkin ? currentSkin.topColor : '',
              color: '#0077FF',
              fontSize: '24px',
              marginRight: '10px'
            }"
            :class="{ iconOpen: isOpen }"
          ></i>
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
import { delCookie } from "@/utils/cookie";
import { logout, userType } from "@/api/index"
import { logoutLocally } from '@/utils/session';
import { setLocale } from "@/utils/locale";
import { Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import { routeTitle } from "@/lang";
import {
  title,
  navMode,
  layoutMode,
  langEnum,
} from "../../../config/project";
// import LogoBox from "../logo";
export default {
  name: "publicNav",
  components: {
    ElDropdown: Dropdown,
    ElDropdownMenu: DropdownMenu,
    ElDropdownItem: DropdownItem,
  },
  props: {
    showBreadcrumb: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pwdShow: false,
      orgShow: false,
      centerShow: false,
      baseBreadcrumb: {
        label: "首页",
        name: "/",
      },
      isOpen: false,
      title,
      navMode,
      langEnum,
      layoutMode,
      activeIndex: "",
      userName: JSON.parse(localStorage.getItem("account")),
      snName:'',
      langMenuVisible: false,
    };
  },
  mounted() {
    // 监听localhostStorage的数据变化，结合utils/tool.js配合使用
    // window.addEventListener('setItemEvent', function(e) {
    // 	const newdata = JSON.parse(e.newValue)
    // 	console.log('值改变了',newdata)
    // 	this.snName = newdata.sn
    // })
    this.$nextTick(()=>{
      this.snName = sessionStorage.getItem("loginName")
    });
  },
  computed: {
    breadcrumb() {
      let res = [];
      const { meta = {}, matched = [], name = "" } = this.$route;
      res.push({
        label: routeTitle(this.$route),
        name,
      });
      if (matched.length && meta.parant) {
        let one = matched.find((f) => f.name == meta.parant);
        res.push({
          label: routeTitle(one),
          name: one.name,
        });
      }
      // res.push(this.baseBreadcrumb);
      return res.reverse();
    },
    isSideOpen() {
      return this.$store.getters.sideNavOpen;
    },
    currentSkin() {
      return this.$store.getters["skin/skinList"].find((f) => f.checked);
    },
    nav() {
      return this.$store.getters.menuList;
    },
    deviceInfo() {
      return this.$store.getters.deviceInfo;
    },
    lang() {
      return this.$store.getters.lang;
    },
    showLang() {
      return this.langEnum.find((f) => f.isCheck);
    },
    curLangLabel() {
      return this.showLang ? this.showLang.label : "";
    },
    selects() {
      return [
        {
          icon: require("@/assets/images/public/base.png"),
          actIcon: require("@/assets/images/public/base_act.png"),
          label: this.$t("nav.base_info"),
          type: "baseInfo",
        },
        {
          icon: require("@/assets/images/public/app.png"),
          actIcon: require("@/assets/images/public/app_act.png"),
          label: this.$t("nav.develop_app"),
          type: "developApp",
        },
        {
          icon: require("@/assets/images/public/logout.png"),
          actIcon: require("@/assets/images/public/logout_act.png"),
          label: this.$t("public.login_out"),
          type: "logout",
        },
      ];
    },
  },
  watch: {
    $route: {
      handler(val) {
        if (this.navMode == "sideTop") {
          this.activeIndex = val.matched.filter((f) => f.path).length
            ? val.matched.filter((f) => f.path)[0].name
            : "";
          this.$store.commit("permission/SET_TOP_LEVEL", this.activeIndex);
        }
        this.snName = JSON.parse(localStorage.getItem("receiverInfo"))
          ? JSON.parse(localStorage.getItem("receiverInfo")).sn
          : "";
      },
      deep: true,
      immediate: true,
    },
    lang: {
      handler(val) {
        this.langEnum.forEach((item) => {
          if (item.type == val) {
            item.isCheck = true;
          } else {
            item.isCheck = false;
          }
        });
      },
      deep: true,
      immediate: true,
    },
    snName: {
      handler(val) {
        this.snName = val;
      },
    },
  },
  methods: {
    routeTitle,
    goDocument(){
      this.$router.push({
        name: "document",
      });
    },
    toggleOpenSide() {
      this.$store.commit("TOGGLE_SIDE_OPEN");
    },
    toggleShow() {
      this.$store.commit("skin/TOGGLE_SHOW_SKIN");
    },
    openScreen() {
      // this.$router.push({
      //   name: "member",
      // });
      const { origin = "" } = location;
      window.open(origin ? `${origin}/#/member` : "##");
    },
    toggleChangeIcon() {
      this.isOpen = !this.isOpen;
    },
    handleClick(e) {
      const { type = "" } = e || {};
      if (!type) {
        return;
      }
      if (type == "logout") {
        this.$messageBox
          .confirm(this.$t("public.login_out_message"), this.$t("public.tip"), {
            confirmButtonText: this.$t("public.submit"),
            cancelButtonText: this.$t("public.cancel"),
            type: "warning",
          })
          .then((res) => {
            logoutLocally(logout, () => {
              this.$store.commit("SET_LOGIN_STATUS", false);
              this.$router.replace({ name: "login" });
            }, () => this.$message.warning(this.$t('resetPwd.logout_unconfirmed')));
          })
          .catch((err) => {});
      } else if (type == "baseInfo") {
        this.$router.push({
          name: "baseInfo",
        });
      } else if (type == "developApp") {
        this.$router.push({
          name: "developApp",
        });
      }
    },
    handleSelect(e) {
      this.$router.push({
        name: e,
      });
      // console.log(e);
    },
    handleChangeLang(e) {
      if (e.type != this.showLang.type) {
        setLocale(e.type);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.publicNav {
  height: 64px;
  background: linear-gradient(90deg, #1353ab 0%, #032664 100%);
  justify-content: space-between;
  line-height: 64px;
  transition: all 0.4s;
  .title {
    height: 100%;
    & > span {
      height: 100%;
      display: inline-block;
      min-width: 210px;
      text-align: center;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #f5f5f5;
    }
    & > i {
      cursor: pointer;
    }
    .breadcrumbSpan {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #deebff;
      cursor: pointer;
    }
  }
  .account {
    .document{
      font-size: 14px;
    }
    .document:hover{
      cursor: pointer;
      text-decoration: underline;
    }
    padding: 0 10px;
    & i {
      color: #fff;
      cursor: pointer;
      font-size: 24px;
      transition-duration: 0.5s;
      display: inline-block;
      & + i {
        margin-left: 20px;
      }
    }
    & > span {
      position: relative;
    }
    &-sn {
      font-size: 16px;
      color: #ffffff;
    }
    &-reveice {
      height: 46px;
      width: auto;
      margin: 0 10px;
    }
    &-info {
      // margin-left: 20px;
      cursor: pointer;
      line-height: unset;
      & i {
        &:last-child {
          // margin-left: 12px;
          font-size: 16px;
        }
      }
    }
    .iconOpen {
      // transform: rotate(180deg);
    }
  }
  .langBox {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    padding: 0 20px;
    cursor: pointer;
    & > img {
      height: 25px;
      width: auto;
    }
    & > span {
      margin: 0 10px;
    }
  }

  // 收进 .account 作用域提升特异度，覆盖 .account i 的 color:#fff/font-size:24px，否则箭头白底隐身
  .account {
    .nav-lang {
      display: inline-flex;
      align-items: center;
      margin-right: 16px;
    }
    .lang-trigger {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      height: 32px;
      padding: 0 10px;
      border: 1px solid #dce3ed;
      border-radius: 16px;
      background: rgba(255, 255, 255, 0.8);
      color: #606b7a;
      font: inherit;
      font-size: 13px;
      line-height: normal;
      cursor: pointer;
      &:hover {
        color: #0077ff;
        border-color: #a9c9ef;
      }
      &:focus-visible {
        outline: 2px solid #0077ff;
        outline-offset: 2px;
      }
    }
    .lang-globe {
      flex: none;
      width: 16px;
      height: 16px;
    }
    .lang-current {
      max-width: 144px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .lang-arrow {
      color: inherit;
      font-size: 10px;
      margin: 0;
      transition: transform 0.2s;
      &.expanded {
        transform: rotate(180deg);
      }
    }
  }

  .topNav {
    flex: 1;
    height: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    &::v-deep .el-menu-item {
      line-height: 54px;
      height: 54px;
    }
    &::v-deep .el-menu-item:not(.is-disabled):hover {
      background-color: rgba(17, 120, 229, 0.6) !important;
    }
    &::v-deep .el-menu-item.is-active {
      // border-color: #1353ab !important;
      background-color: #1178e5 !important;
    }
  }
  .small {
    flex: 1;
    line-height: 48px;
    height: 48px;
    position: relative;
    .langBox {
      padding: 0;
      font-size: 14px;
      & > span {
        margin: 0 4px;
        max-width: 28px;
        overflow: hidden;
      }
    }
    &-icon {
      justify-content: center;
      width: 48px;
      font-size: 18px;
      cursor: pointer;
      height: 48px;
    }
    .flexd {
      position: fixed;
      left: 0;
      top: 0;
      z-index: 50;
    }
    &-title {
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
      height: 48px;
      max-width: 50%;
      overflow: hidden;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }
}
.account-select {
  .select-one {
    padding: 6px 20px;
    transition-duration: 0.4s;
    position: relative;
    line-height: 24px;
    cursor: pointer;
    & > img {
      width: 16px;
      height: 16px;
    }
    .img {
      display: block;
    }
    .img_act {
      display: none;
    }
    &:hover {
      // background-color: $main_color;
      background-color: rgba(22,119,255,0.1);;
      color: #0077FF;
      .img {
        display: none;
      }
      .img_act {
        display: block;
      }
    }
    & > span {
      flex: 1;
      text-align: center;
      padding-left: 8px;
    }
  }
}
.PC {
  // background-image: url("../../../assets/images/public/top_bg.png") !important;
  background-position: center !important;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
}
</style>

<style lang="scss">
.langList {
  min-width: 180px;
  & > * {
    height: 38px;
    line-height: 38px;
    z-index: 1;
  }
  & > div {
    color: #333;
    cursor: pointer;
  }
  & img {
    height: 25px;
    width: auto;
    margin-right: 10px;
    z-index: 1;
  }
  & span {
    z-index: 1;
  }
  .langListCheck {
    position: relative;

    color: #fff;
    &::before {
      content: "";
      position: absolute;
      width: calc(100% + 26px);
      // background: #539d56;
      height: 100%;
      z-index: 0;
      left: -13px;
    }
  }
}
.select-popover {
  padding: 0;
}
.nav-lang-menu {
  min-width: 168px;
  max-height: 280px;
  overflow-y: auto;
  padding: 6px 0;
  border-radius: 8px;
}
.nav-lang-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  font-size: 13px;
  white-space: nowrap;
  &.active {
    color: #0077ff;
    background-color: #f0f6ff;
    font-weight: 500;
  }
}
</style>
